import React from 'react';
import PropTypes from 'prop-types';

function Input({ name, label, ...props }) {
  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="mt-1 rounded-lg border border-gray-300 focus-within:border-primary-600">
        <input
          type="text"
          name={name}
          id={name}
          className="block w-full border-0 focus:border-primary-600 focus:ring-0 sm:text-sm focus:outline-none px-3 py-2 rounded-lg"
          {...props}
        />
      </div>
    </div>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default Input;
